import { c as _c } from "react/compiler-runtime";
import { Dialog, LinkButton } from '@onefootprint/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code';
type AboutAppClipAndInstantAppProps = {
  kind: 'appClip' | 'instantApp';
};
const AboutAppClipAndInstantApp = t0 => {
  const $ = _c(39);
  const {
    kind
  } = t0;
  const t1 = `deviceInsights.${kind}`;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      keyPrefix: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    t
  } = useTranslation("entity-details", t2);
  const [isOpen, setIsOpen] = useState(false);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsOpen(false);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleClose = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsOpen(true);
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t) {
    t5 = t(_temp);
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <LinkButton onClick={t4}>{t5}</LinkButton>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t) {
    t7 = t(_temp2);
    $[8] = t;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t) {
    t8 = t(_temp3);
    $[10] = t;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t8) {
    t9 = <span className="text-body-2 text-primary">{t8}</span>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t) {
    t10 = t(_temp4);
    $[14] = t;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10) {
    t11 = <span className="text-body-2 text-primary">{t10}</span>;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="my-4"><QRCode value="https://handoff.onefootprint.com/appclip?demo=true#1234512345" size={128} /></div>;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t) {
    t13 = t(_temp5);
    $[19] = t;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t13) {
    t14 = <span className="text-body-2 text-secondary">{t13}</span>;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t) {
    t15 = t(_temp6);
    $[23] = t;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t15) {
    t16 = <span className="text-body-2 text-tertiary text-center">{t15}</span>;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t11 || $[28] !== t14 || $[29] !== t16) {
    t17 = <div className="flex flex-col items-center gap-1 mt-6 text-center">{t11}{t12}{t14}{t16}</div>;
    $[27] = t11;
    $[28] = t14;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== isOpen || $[32] !== t17 || $[33] !== t7 || $[34] !== t9) {
    t18 = <Dialog onClose={handleClose} open={isOpen} size="compact" title={t7}>{t9}{t17}</Dialog>;
    $[31] = isOpen;
    $[32] = t17;
    $[33] = t7;
    $[34] = t9;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t18 || $[37] !== t6) {
    t19 = <>{t6}{t18}</>;
    $[36] = t18;
    $[37] = t6;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  return t19;
};
export default AboutAppClipAndInstantApp;
function _temp($) {
  return $.about;
}
function _temp2($_0) {
  return $_0.dialog.title;
}
function _temp3($_1) {
  return $_1.dialog.content;
}
function _temp4($_2) {
  return $_2.dialog.demo;
}
function _temp5($_3) {
  return $_3.dialog.instructions;
}
function _temp6($_4) {
  return $_4.dialog.disclaimer;
}